import React, { useState, useEffect, Suspense } from "react";
import { useSelector } from "react-redux";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";

import SingleDatePicker from "../../DatePickers/SingleDatePicker/SingleDatePicker";

import WaveformAnalysisApi from "../../../api/WaveformApi";

import LeftFilterBox from "../../LeftFilterBox/LeftFilterBox";

import Dropdown from "react-dropdown";
import Cookies from "js-cookie";
import ReactLoading from "react-loading";

import WaveformAnalysis from "./components/Waveform/Waveform";
import RTWaveform from "./components/RTWaveform/RTWavefrom";

const WaveformAnalysisPlot = React.lazy(() => import("../../plots/WaveformAnalysisPlot"));
const RealTimeWaveformPlot = React.lazy(() => import("../../plots/RealTimeWaveformPlot"));

const formatDate = (date) => {
    return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
};

export default function WaveformAnalysisTab() {
    const customer = useSelector((state) => state.equipmentsPortfolio.customerList[0].label);
    const { earlyAccess, mobileUnitAdmin } = useSelector((state) => state.user);

    const [plotsOrder, setPlotsOrder] = useState({
        waveform: 1,
        rtWaveform: 2,
    });

    const [waveformTabData, setWaveformTabData] = useState({
        plotData: "",
        showPlot: false,
        plotMetaData: {},
        isPlotLoading: false,
    });

    const [rtWaveformTabData, setRTWaveformTabData] = useState({
        plotData: {
            Time: [],
            Ia: [],
            Ib: [],
            Ic: [],
            Va: [],
            Vb: [],
            Vc: [],
            Np_I_peak: { x: "", y: "" },
        },
        tableData: { rows: "", columns: [""] },
        plotMetaData: "",
        showPlot: false,
        isPlotLoading: false,
    });

    const hasRTWaveform = customer === "Factory Mutual Insurance Company" || mobileUnitAdmin;

    return (
        <div>
            <Card>
                <Card.Body>
                    <Row className="mt-3">
                        {/************************************ Facility and Node Selection Column **************************************************************/}
                        <Col className="col-4">
                            <LeftFilterBox />
                        </Col>
                        {/************************************************* Sub Menu Tabs **********************************************************************/}
                        <Col className="col-8">
                            <Card>
                                <Card.Body>
                                    <Tabs defaultActiveKey="Waveforms" variant="pills">
                                        {/* **************************************** WaveForm Tabs **************************************** */}
                                        <Tab eventKey="Waveforms" title="Waveforms">
                                            <WaveformAnalysis
                                                tabData={waveformTabData}
                                                setTabData={setWaveformTabData}
                                            />
                                        </Tab>
                                        {hasRTWaveform && (
                                            <Tab eventKey="RTWaveforms" title="Real-Time Waveforms">
                                                <RTWaveform
                                                    tabData={rtWaveformTabData}
                                                    setTabData={setRTWaveformTabData}
                                                    setPlotsOrder={setPlotsOrder}
                                                />
                                            </Tab>
                                        )}
                                    </Tabs>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <br></br>
            {/********************************************** Plot Section ***************************************************************************/}
            <Suspense fallback={<div>Loading..</div>}>
                <Row>
                    <Col lg={{ order: plotsOrder.waveform, span: 12 }}>
                        <WaveformAnalysisPlot tabData={waveformTabData} setTabData={setWaveformTabData} />
                    </Col>
                    <Col lg={{ order: plotsOrder.rtWaveform, span: 12 }}>
                        <RealTimeWaveformPlot tabData={rtWaveformTabData} setTabData={setRTWaveformTabData} />
                    </Col>
                </Row>
            </Suspense>
        </div>
    );
}
